<template>
  <div class="main-wrap">


    <!-- ✅ 支付成功视图 -->
    <div v-if="payResult === 'success'" class="payment-mask">

      <div class="payment-dialog">

        <div class="success-icon">
          ✓
        </div>

        <h2 class="dialog-title">
          Payment Successful
        </h2>

        <p class="success-text">
          Your payment has been completed successfully.
        </p>

        <div class="dialog-info">

          <div class="info-item">
            <span class="label">Order No</span>
            <span>{{ resultData.orderNo }}</span>
          </div>

          <div class="info-item">
            <span class="label">Amount</span>
            <span>{{ resultData.amount }} {{ resultData.currency }}</span>
          </div>

          <div class="info-item">
            <span class="label">Order Date</span>
            <span>{{ resultData.dates }}</span>
          </div>

        </div>

        <button
            class="submit-btn success-btn"
            @click="resetForm">

          Back to Home

        </button>

      </div>

    </div>

    <!-- ❌ 支付失败视图 -->
<!--    <div v-else-if="payResult === 'failed'" class="result-container">
      <div class="failed-icon">×</div>
      <h1>Payment Failed</h1>
      <p class="reason">{{ resultData.reason }}</p>
      <br />
      <p><span class="label">Order No:</span> {{ resultData.orderNo }}</p>
      <p><span class="label">Amount:</span> {{ resultData.amount }}{{ resultData.currency }}</p>
      <p><span class="label">Order Date:</span> {{ resultData.dates }}</p>
      <br />
      <button class="submit-btn btn-failed" @click="resetForm">Try Again</button>
    </div>-->
    <div v-if="payResult === 'failed'" class="payment-mask">
      <div class="payment-dialog">
        <div class="failed-icon">
          ×
        </div>
        <h2 class="dialog-title">
          Payment Failed
        </h2>
        <p class="reason">
          {{ resultData.reason }}
        </p>
        <div class="dialog-info">
          <div class="info-item">
            <span class="label">Order No</span>
            <span>{{ resultData.orderNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">Amount</span>
            <span>{{ resultData.amount }} {{ resultData.currency }}</span>
          </div>
          <div class="info-item">
            <span class="label">Order Date</span>
            <span>{{ resultData.dates }}</span>
          </div>
        </div>
        <button
            class="submit-btn"
            @click="resetForm">
          Retry Payment
        </button>
      </div>
    </div>

    <!-- 左侧订单信息 -->
    <div class="left-order">
      <h3 class="left-title">Order Information</h3>

      <div class="order-item">
        <div class="order-label">Order No.</div>
        <div class="order-val">{{ orderInfo.merOrder }}</div>
      </div>

      <div class="order-item">
        <div class="order-label">Amount</div>
        <div class="order-val">{{ orderInfo.amount }}</div>
      </div>

      <div class="order-item">
        <div class="order-label">Currency</div>
        <div class="order-val">{{ orderInfo.currency }}</div>
      </div>
    </div>

    <!-- 右侧支付表单 -->
    <div class="right-form">

      <h3 class="form-title">Payment Details</h3>

      <form @submit.prevent="submitPayment">

        <!-- 隐藏字段 -->
        <input
            type="hidden"
            v-model="form.info">

        <!-- 卡号 + CVV -->
        <div class="form-row">

          <div class="form-col">
            <div class="form-group">
              <label>
                Card Number
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.cardNo"
                  type="text"
                  placeholder="Enter card number">
            </div>
          </div>

          <div class="form-col">
            <div class="form-group">
              <label>
                CVV
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.cvv"
                  type="text"
                  placeholder="CVV code">
            </div>
          </div>

        </div>

        <!-- 有效期 -->
        <div class="form-row">

          <div class="form-col">
            <div class="form-group">

              <label>
                Expire Year
                <span class="required">*</span>
              </label>

              <select
                  v-model="form.expYear"
                  @change="changeMonth">

                <option value="">Select Year</option>

                <option
                    v-for="item in yearList"
                    :key="item"
                    :value="item">
                  {{ item }}
                </option>

              </select>

            </div>
          </div>

          <div class="form-col">
            <div class="form-group">

              <label>
                Expire Month
                <span class="required">*</span>
              </label>

              <select v-model="form.expMonth">

                <option value="">Select Month</option>

                <option
                    v-for="item in monthList"
                    :key="item"
                    :value="item">
                  {{ item }}
                </option>

              </select>

            </div>
          </div>

        </div>

        <!-- 姓名 -->
        <div class="form-row">

          <div class="form-col">
            <div class="form-group">

              <label>
                First Name
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.firstName"
                  type="text"
                  placeholder="First name">

            </div>
          </div>

          <div class="form-col">
            <div class="form-group">

              <label>
                Last Name
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.lastName"
                  type="text"
                  placeholder="Last name">

            </div>
          </div>

        </div>

        <!-- 邮箱 手机 -->
        <div class="form-row">

          <div class="form-col">
            <div class="form-group">

              <label>
                Email
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.email"
                  type="text"
                  placeholder="example@mail.com">

            </div>
          </div>

          <div class="form-col">
            <div class="form-group">

              <label>
                Phone
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.phone"
                  type="text"
                  placeholder="Phone number">

            </div>
          </div>

        </div>

        <!-- 国家 州 -->
<!--        <div class="form-row">

          <div class="form-col">
            <div class="form-group">

              <label>
                Country
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.country"
                  type="text"
                  placeholder="Country">

            </div>
          </div>

          <div class="form-col">
            <div class="form-group">

              <label>
                State
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.state"
                  type="text"
                  placeholder="State / Province">

            </div>
          </div>

        </div>-->
        <div class="form-col">
          <div class="form-group">
            <label>
              Country
              <span class="required">*</span>
            </label>
            <select v-model="form.country" required>
              <option value="">-- Select Country  --</option>
              <option
                  v-for="item in countryList"
                  :key="item.code"
                  :value="item.code">
                {{ item.en }} ({{ item.cn }})
              </option>
            </select>
          </div>
        </div>


        <div class="form-col">
          <div class="form-group">
            <label>
              State
              <span class="required">*</span>
            </label>

            <!-- 美国/加拿 显示下拉框 -->
            <select
                v-if="isStateDropdown"
                v-model="form.state"
                required>
              <option value="">-- Select State --</option>
              <option
                  v-for="item in stateList"
                  :key="item.code"
                  :value="item.code">
                {{ item.name }}
              </option>
            </select>

            <!-- 其他国家 保持原来的文本输入框 -->
            <input
                v-else
                v-model.trim="form.state"
                type="text"
                placeholder="State / Province"
                required>
          </div>
        </div>

        <!-- 城市 邮编 -->
        <div class="form-row">

          <div class="form-col">
            <div class="form-group">

              <label>
                City
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.city"
                  type="text"
                  placeholder="City">

            </div>
          </div>

          <div class="form-col">
            <div class="form-group">

              <label>
                Zip Code
                <span class="required">*</span>
              </label>

              <input
                  v-model.trim="form.zipCode"
                  type="text"
                  placeholder="Zip code">

            </div>
          </div>

        </div>

        <!-- 地址 -->
        <div class="form-group">

          <label>
            Address
            <span class="required">*</span>
          </label>

          <input
              v-model.trim="form.address"
              type="text"
              placeholder="Full street address">

        </div>

        <button
            class="submit-btn"
            type="submit"
            :disabled="submitting">

          {{ submitting ? 'Submitting...' : 'Submit Payment' }}

        </button>

      </form>

    </div>

  </div>
</template>

<script>

const COUNTRY_LIST = [
  { code: 'AF', en: 'Afghanistan', cn: 'AF' },
  { code: 'AX', en: 'Åland Islands', cn: 'AX' },
  { code: 'AL', en: 'Albania', cn: 'AL' },
  { code: 'DZ', en: 'Algeria', cn: 'DZ' },
  { code: 'AS', en: 'American Samoa', cn: 'AS' },
  { code: 'AD', en: 'Andorra', cn: 'AD' },
  { code: 'AO', en: 'Angola', cn: 'AO' },
  { code: 'AI', en: 'Anguilla', cn: 'AI' },
  { code: 'AQ', en: 'Antarctica', cn: 'AQ' },
  { code: 'AG', en: 'Antigua and Barbuda', cn: 'AG' },
  { code: 'AR', en: 'Argentina', cn: 'AR' },
  { code: 'AM', en: 'Armenia', cn: 'AM' },
  { code: 'AW', en: 'Aruba', cn: 'AW' },
  { code: 'AU', en: 'Australia', cn: 'AU' },
  { code: 'AT', en: 'Austria', cn: 'AT' },
  { code: 'AZ', en: 'Azerbaijan', cn: 'AZ' },
  { code: 'BS', en: 'Bahamas', cn: 'BS' },
  { code: 'BH', en: 'Bahrain', cn: 'BH' },
  { code: 'BD', en: 'Bangladesh', cn: 'BD' },
  { code: 'BB', en: 'Barbados', cn: 'BB' },
  { code: 'BY', en: 'Belarus', cn: 'BY' },
  { code: 'BE', en: 'Belgium', cn: 'BE' },
  { code: 'BZ', en: 'Belize', cn: 'BZ' },
  { code: 'BJ', en: 'Benin', cn: 'BJ' },
  { code: 'BM', en: 'Bermuda', cn: 'BM' },
  { code: 'BT', en: 'Bhutan', cn: 'BT' },
  { code: 'BO', en: 'Bolivia', cn: 'BO' },
  { code: 'BQ', en: 'Bonaire, Sint Eustatius and Saba', cn: 'BQ' },
  { code: 'BA', en: 'Bosnia and Herzegovina', cn: 'BA' },
  { code: 'BW', en: 'Botswana', cn: 'BW' },
  { code: 'BV', en: 'Bouvet Island', cn: 'BV' },
  { code: 'BR', en: 'Brazil', cn: 'BR' },
  { code: 'IO', en: 'British Indian Ocean Territory', cn: 'IO' },
  { code: 'BN', en: 'Brunei Darussalam', cn: 'BN' },
  { code: 'BG', en: 'Bulgaria', cn: 'BG' },
  { code: 'BF', en: 'Burkina Faso', cn: 'BF' },
  { code: 'BI', en: 'Burundi', cn: 'BI' },
  { code: 'CV', en: 'Cabo Verde', cn: 'CV' },
  { code: 'KH', en: 'Cambodia', cn: 'KH' },
  { code: 'CM', en: 'Cameroon', cn: 'CM' },
  { code: 'CA', en: 'Canada', cn: 'CA' },
  { code: 'KY', en: 'Cayman Islands', cn: 'KY' },
  { code: 'CF', en: 'Central African Republic', cn: 'CF' },
  { code: 'TD', en: 'Chad', cn: 'TD' },
  { code: 'CL', en: 'Chile', cn: 'CL' },
  { code: 'CN', en: 'China', cn: 'CN' },
  { code: 'CX', en: 'Christmas Island', cn: 'CX' },
  { code: 'CC', en: 'Cocos (Keeling) Islands', cn: 'CC' },
  { code: 'CO', en: 'Colombia', cn: 'CO' },
  { code: 'KM', en: 'Comoros', cn: 'KM' },
  { code: 'CG', en: 'Congo', cn: 'CG' },
  { code: 'CD', en: 'Congo, Democratic Republic of the', cn: 'CD' },
  { code: 'CK', en: 'Cook Islands', cn: 'CK' },
  { code: 'CR', en: 'Costa Rica', cn: 'CR' },
  { code: 'CI', en: "Côte d'Ivoire", cn: 'CI' },
  { code: 'HR', en: 'Croatia', cn: 'HR' },
  { code: 'CU', en: 'Cuba', cn: 'CU' },
  { code: 'CW', en: 'Curaçao', cn: 'CW' },
  { code: 'CY', en: 'Cyprus', cn: 'CY' },
  { code: 'CZ', en: 'Czechia', cn: 'CZ' },
  { code: 'DK', en: 'Denmark', cn: 'DK' },
  { code: 'DJ', en: 'Djibouti', cn: 'DJ' },
  { code: 'DM', en: 'Dominica', cn: 'DM' },
  { code: 'DO', en: 'Dominican Republic', cn: 'DO' },
  { code: 'EC', en: 'Ecuador', cn: 'EC' },
  { code: 'EG', en: 'Egypt', cn: 'EG' },
  { code: 'SV', en: 'El Salvador', cn: 'SV' },
  { code: 'GQ', en: 'Equatorial Guinea', cn: 'GQ' },
  { code: 'ER', en: 'Eritrea', cn: 'ER' },
  { code: 'EE', en: 'Estonia', cn: 'EE' },
  { code: 'SZ', en: 'Eswatini', cn: 'SZ' },
  { code: 'ET', en: 'Ethiopia', cn: 'ET' },
  { code: 'FK', en: 'Falkland Islands (Malvinas)', cn: 'FK' },
  { code: 'FO', en: 'Faroe Islands', cn: 'FO' },
  { code: 'FJ', en: 'Fiji', cn: 'FJ' },
  { code: 'FI', en: 'Finland', cn: 'FI' },
  { code: 'FR', en: 'France', cn: 'FR' },
  { code: 'GF', en: 'French Guiana', cn: 'GF' },
  { code: 'PF', en: 'French Polynesia', cn: 'PF' },
  { code: 'TF', en: 'French Southern Territories', cn: 'TF' },
  { code: 'GA', en: 'Gabon', cn: 'GA' },
  { code: 'GM', en: 'Gambia', cn: 'GM' },
  { code: 'GE', en: 'Georgia', cn: 'GE' },
  { code: 'DE', en: 'Germany', cn: 'DE' },
  { code: 'GH', en: 'Ghana', cn: 'GH' },
  { code: 'GI', en: 'Gibraltar', cn: 'GI' },
  { code: 'GR', en: 'Greece', cn: 'GR' },
  { code: 'GL', en: 'Greenland', cn: 'GL' },
  { code: 'GD', en: 'Grenada', cn: 'GD' },
  { code: 'GP', en: 'Guadeloupe', cn: 'GP' },
  { code: 'GU', en: 'Guam', cn: 'GU' },
  { code: 'GT', en: 'Guatemala', cn: 'GT' },
  { code: 'GG', en: 'Guernsey', cn: 'GG' },
  { code: 'GN', en: 'Guinea', cn: 'GN' },
  { code: 'GW', en: 'Guinea-Bissau', cn: 'GW' },
  { code: 'GY', en: 'Guyana', cn: 'GY' },
  { code: 'HT', en: 'Haiti', cn: 'HT' },
  { code: 'HM', en: 'Heard Island and McDonald Islands', cn: 'HM' },
  { code: 'VA', en: 'Holy See', cn: 'VA' },
  { code: 'HN', en: 'Honduras', cn: 'HN' },
  { code: 'HK', en: 'Hong Kong SAR China', cn: 'HK' },
  { code: 'HU', en: 'Hungary', cn: 'HU' },
  { code: 'IS', en: 'Iceland', cn: 'IS' },
  { code: 'IN', en: 'India', cn: 'IN' },
  { code: 'ID', en: 'Indonesia', cn: 'ID' },
  { code: 'IR', en: 'Iran', cn: 'IR' },
  { code: 'IQ', en: 'Iraq', cn: 'IQ' },
  { code: 'IE', en: 'Ireland', cn: 'IE' },
  { code: 'IM', en: 'Isle of Man', cn: 'IM' },
  { code: 'IL', en: 'Israel', cn: 'IL' },
  { code: 'IT', en: 'Italy', cn: 'IT' },
  { code: 'JM', en: 'Jamaica', cn: 'JM' },
  { code: 'JP', en: 'Japan', cn: 'JP' },
  { code: 'JE', en: 'Jersey', cn: 'JE' },
  { code: 'JO', en: 'Jordan', cn: 'JO' },
  { code: 'KZ', en: 'Kazakhstan', cn: 'KZ' },
  { code: 'KE', en: 'Kenya', cn: 'KE' },
  { code: 'KI', en: 'Kiribati', cn: 'KI' },
  { code: 'KP', en: "Korea (Democratic People's Republic of)", cn: 'KP' },
  { code: 'KR', en: 'Korea, Republic of', cn: 'KR' },
  { code: 'KW', en: 'Kuwait', cn: 'KW' },
  { code: 'KG', en: 'Kyrgyzstan', cn: 'KG' },
  { code: 'LA', en: "Lao People's Democratic Republic", cn: 'LA' },
  { code: 'LV', en: 'Latvia', cn: 'LV' },
  { code: 'LB', en: 'Lebanon', cn: 'LB' },
  { code: 'LS', en: 'Lesotho', cn: 'LS' },
  { code: 'LR', en: 'Liberia', cn: 'LR' },
  { code: 'LY', en: 'Libya', cn: 'LY' },
  { code: 'LI', en: 'Liechtenstein', cn: 'LI' },
  { code: 'LT', en: 'Lithuania', cn: 'LT' },
  { code: 'LU', en: 'Luxembourg', cn: 'LU' },
  { code: 'MO', en: 'Macao SAR China', cn: 'MO' },
  { code: 'MG', en: 'Madagascar', cn: 'MG' },
  { code: 'MW', en: 'Malawi', cn: 'MW' },
  { code: 'MY', en: 'Malaysia', cn: 'MY' },
  { code: 'MV', en: 'Maldives', cn: 'MV' },
  { code: 'ML', en: 'Mali', cn: 'ML' },
  { code: 'MT', en: 'Malta', cn: 'MT' },
  { code: 'MH', en: 'Marshall Islands', cn: 'MH' },
  { code: 'MQ', en: 'Martinique', cn: 'MQ' },
  { code: 'MR', en: 'Mauritania', cn: 'MR' },
  { code: 'MU', en: 'Mauritius', cn: 'MU' },
  { code: 'YT', en: 'Mayotte', cn: 'YT' },
  { code: 'MX', en: 'Mexico', cn: 'MX' },
  { code: 'FM', en: 'Micronesia', cn: 'FM' },
  { code: 'MD', en: 'Moldova', cn: 'MD' },
  { code: 'MC', en: 'Monaco', cn: 'MC' },
  { code: 'MN', en: 'Mongolia', cn: 'MN' },
  { code: 'ME', en: 'Montenegro', cn: 'ME' },
  { code: 'MS', en: 'Montserrat', cn: 'MS' },
  { code: 'MA', en: 'Morocco', cn: 'MA' },
  { code: 'MZ', en: 'Mozambique', cn: 'MZ' },
  { code: 'MM', en: 'Myanmar', cn: 'MM' },
  { code: 'NA', en: 'Namibia', cn: 'NA' },
  { code: 'NR', en: 'Nauru', cn: 'NR' },
  { code: 'NP', en: 'Nepal', cn: 'NP' },
  { code: 'NL', en: 'Netherlands', cn: 'NL' },
  { code: 'NC', en: 'New Caledonia', cn: 'NC' },
  { code: 'NZ', en: 'New Zealand', cn: 'NZ' },
  { code: 'NI', en: 'Nicaragua', cn: 'NI' },
  { code: 'NE', en: 'Niger', cn: 'NE' },
  { code: 'NG', en: 'Nigeria', cn: 'NG' },
  { code: 'NU', en: 'Niue', cn: 'NU' },
  { code: 'NF', en: 'Norfolk Island', cn: 'NF' },
  { code: 'MK', en: 'North Macedonia', cn: 'MK' },
  { code: 'MP', en: 'Northern Mariana Islands', cn: 'MP' },
  { code: 'NO', en: 'Norway', cn: 'NO' },
  { code: 'OM', en: 'Oman', cn: 'OM' },
  { code: 'PK', en: 'Pakistan', cn: 'PK' },
  { code: 'PW', en: 'Palau', cn: 'PW' },
  { code: 'PS', en: 'Palestine, State of', cn: 'PS' },
  { code: 'PA', en: 'Panama', cn: 'PA' },
  { code: 'PG', en: 'Papua New Guinea', cn: 'PG' },
  { code: 'PY', en: 'Paraguay', cn: 'PY' },
  { code: 'PE', en: 'Peru', cn: 'PE' },
  { code: 'PH', en: 'Philippines', cn: 'PH' },
  { code: 'PN', en: 'Pitcairn', cn: 'PN' },
  { code: 'PL', en: 'Poland', cn: 'PL' },
  { code: 'PT', en: 'Portugal', cn: 'PT' },
  { code: 'PR', en: 'Puerto Rico', cn: 'PR' },
  { code: 'QA', en: 'Qatar', cn: 'QA' },
  { code: 'RE', en: 'Réunion', cn: 'RE' },
  { code: 'RO', en: 'Romania', cn: 'RO' },
  { code: 'RU', en: 'Russian Federation', cn: 'RU' },
  { code: 'RW', en: 'Rwanda', cn: 'RW' },
  { code: 'BL', en: 'Saint Barthélemy', cn: 'BL' },
  { code: 'SH', en: 'Saint Helena, Ascension and Tristan da Cunha', cn: 'SH' },
  { code: 'KN', en: 'Saint Kitts and Nevis', cn: 'KN' },
  { code: 'LC', en: 'Saint Lucia', cn: 'LC' },
  { code: 'MF', en: 'Saint Martin (French part)', cn: 'MF' },
  { code: 'PM', en: 'Saint Pierre and Miquelon', cn: 'PM' },
  { code: 'VC', en: 'Saint Vincent and the Grenadines', cn: 'VC' },
  { code: 'WS', en: 'Samoa', cn: 'WS' },
  { code: 'SM', en: 'San Marino', cn: 'SM' },
  { code: 'ST', en: 'Sao Tome and Principe', cn: 'ST' },
  { code: 'SA', en: 'Saudi Arabia', cn: 'SA' },
  { code: 'SN', en: 'Senegal', cn: 'SN' },
  { code: 'RS', en: 'Serbia', cn: 'RS' },
  { code: 'SC', en: 'Seychelles', cn: 'SC' },
  { code: 'SL', en: 'Sierra Leone', cn: 'SL' },
  { code: 'SG', en: 'Singapore', cn: 'SG' },
  { code: 'SX', en: 'Sint Maarten (Dutch part)', cn: 'SX' },
  { code: 'SK', en: 'Slovakia', cn: 'SK' },
  { code: 'SI', en: 'Slovenia', cn: 'SI' },
  { code: 'SB', en: 'Solomon Islands', cn: 'SB' },
  { code: 'SO', en: 'Somalia', cn: 'SO' },
  { code: 'ZA', en: 'South Africa', cn: 'ZA' },
  { code: 'GS', en: 'South Georgia and the South Sandwich Islands', cn: 'GS' },
  { code: 'SS', en: 'South Sudan', cn: 'SS' },
  { code: 'ES', en: 'Spain', cn: 'ES' },
  { code: 'LK', en: 'Sri Lanka', cn: 'LK' },
  { code: 'SD', en: 'Sudan', cn: 'SD' },
  { code: 'SR', en: 'Suriname', cn: 'SR' },
  { code: 'SJ', en: 'Svalbard and Jan Mayen', cn: 'SJ' },
  { code: 'SE', en: 'Sweden', cn: 'SE' },
  { code: 'CH', en: 'Switzerland', cn: 'CH' },
  { code: 'SY', en: 'Syrian Arab Republic', cn: 'SY' },
  { code: 'TW', en: 'Taiwan, China', cn: 'TW' },
  { code: 'TJ', en: 'Tajikistan', cn: 'TJ' },
  { code: 'TZ', en: 'Tanzania', cn: 'TZ' },
  { code: 'TH', en: 'Thailand', cn: 'TH' },
  { code: 'TL', en: 'Timor-Leste', cn: 'TL' },
  { code: 'TG', en: 'Togo', cn: 'TG' },
  { code: 'TK', en: 'Tokelau', cn: 'TK' },
  { code: 'TO', en: 'Tonga', cn: 'TO' },
  { code: 'TT', en: 'Trinidad and Tobago', cn: 'TT' },
  { code: 'TN', en: 'Tunisia', cn: 'TN' },
  { code: 'TR', en: 'Türkiye', cn: 'TR' },
  { code: 'TM', en: 'Turkmenistan', cn: 'TM' },
  { code: 'TC', en: 'Turks and Caicos Islands', cn: 'TC' },
  { code: 'TV', en: 'Tuvalu', cn: 'TV' },
  { code: 'UG', en: 'Uganda', cn: 'UG' },
  { code: 'UA', en: 'Ukraine', cn: 'UA' },
  { code: 'AE', en: 'United Arab Emirates', cn: 'AE' },
  { code: 'GB', en: 'United Kingdom', cn: 'GB' },
  { code: 'US', en: 'United States of America', cn: 'US' },
  { code: 'UM', en: 'United States Minor Outlying Islands', cn: 'UM' },
  { code: 'UY', en: 'Uruguay', cn: 'UY' },
  { code: 'UZ', en: 'Uzbekistan', cn: 'UZ' },
  { code: 'VU', en: 'Vanuatu', cn: 'VU' },
  { code: 'VE', en: 'Venezuela', cn: 'VE' },
  { code: 'VN', en: 'Viet Nam', cn: 'VN' },
  { code: 'VG', en: 'Virgin Islands (British)', cn: 'VG' },
  { code: 'VI', en: 'Virgin Islands (U.S.)', cn: 'VI' },
  { code: 'WF', en: 'Wallis and Futuna', cn: 'WF' },
  { code: 'EH', en: 'Western Sahara', cn: 'EH' },
  { code: 'YE', en: 'Yemen', cn: 'YE' },
  { code: 'ZM', en: 'Zambia', cn: 'ZM' },
  { code: 'ZW', en: 'Zimbabwe', cn: 'ZW' }
];


const US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' },
  { code: 'AS', name: 'American Samoa' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' }, { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' }, { code: 'DC', name: 'District of Columbia' },
  { code: 'FM', name: 'Federated States of Micronesia' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'GU', name: 'Guam' },
  { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' }, { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MH', name: 'Marshall Islands' },
  { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'MP', name: 'Northern Mariana Islands' },
  { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Pennsylvania' }, { code: 'PR', name: 'Puerto Rico' },
  { code: 'RI', name: 'Rhode Island' }, { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' }, { code: 'VI', name: 'Virgin Islands' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
];

const CA_STATES = [
  { code: 'AB', name: 'Alberta' }, { code: 'BC', name: 'British Columbia' },
  { code: 'MB', name: 'Manitoba' }, { code: 'NB', name: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador' }, { code: 'NT', name: 'Northwest Territories' },
  { code: 'NS', name: 'Nova Scotia' }, { code: 'NU', name: 'Nunavut' },
  { code: 'ON', name: 'Ontario' }, { code: 'PE', name: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec' }, { code: 'SK', name: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon' }
];

export default {
  name: "Payment",

  data() {
    return {
      orderInfo: {
        merOrder: "",
        amount: "",
        currency: ""
      },

      form: {
        info: "",

        cardNo: "",
        cvv: "",

        expYear: "",
        expMonth: "",

        firstName: "",
        lastName: "",

        email: "",
        phone: "",

        country: "",
        state: "",

        city: "",
        zipCode: "",

        address: ""
      },
      payWindow:null,
      // 支付结果
      payResult: null, // null | 'success' | 'failed'
      resultData: {
        orderNo: '',
        amount: '',
        currency: '',
        dates: '',
        reason: ''
      },

      countryList: COUNTRY_LIST,

      yearList: [],
      monthList: [],

      submitting: false
    };
  },

  created() {
    // 从 URL 获取 info
    var info = '';
    if (this.$route && this.$route.query && this.$route.query.info) {
      info = this.$route.query.info;
    } else {
      // 从原生 URL 解析
      var params = new URLSearchParams(window.location.search);
      info = params.get('info') || '';
    }

    if (!info) {
      this.$message.error('Missing required parameter: info');
      return;
    }

    this.form.info = info;

    // 用 info 换取订单展示信息
    this.fetchOrderInfo(info);
    this.initYear();
  },
  computed: {
    // 根据选中国家返回对应的州省列表
    stateList() {
      if (this.form.country === 'US') return US_STATES;
      if (this.form.country === 'CA') return CA_STATES;
      return [];
    },
    // 是否应该显示下拉框
    isStateDropdown() {
      return this.stateList.length > 0;
    }
  },
  watch: {

    'form.country'(newVal) {
      if (newVal !== 'US' && newVal !== 'CA') {
        this.form.state = '';
      } else {
        // 切换到有下拉框的国家时也清空，避免旧值不匹配
        this.form.state = '';
      }
    }
  },

  methods: {
    async fetchOrderInfo(info) {
      try {
        // 把 info 原样传给后端，后端负责解密并返回订单数据
        const res = await this.$axios.get('/api/pay/verify', {
          params: { info }
        });

        this.orderInfo = {
          merOrder: res.data.data.merOrder,
          amount: res.data.data.amount,
          currency: res.data.data.currency
        };
      } catch (e) {
        console.error(e);
        this.$message.error('Failed to load order information');
      }
    },

    async submitPayment() {
      if (!this.validateForm()) {
        return;
      }

      this.submitting = true;
      try {

        const res = await this.$axios.post("/api/pay/sendr", this.form);
        if(res.data.code === 0){
          const d = res.data.data
          this.resultData = {
            orderNo: d.orderNo || '-',
            amount: d.amount || '0',
            currency: d.currency || '',
            dates: d.dates || '-',
            reason: d.reason || 'Unknown Error'
          };

          if (d.payStatus === '1') {
            this.payResult = 'success';
          } else if(d.payStatus === '-1'){
            //window.open(d.redirectUrl, '_blank');  4111111111111111
            //window.location.href = d.redirectUrl;
            if (!d.redirectUrl) {
              if (this.payWindow && !this.payWindow.closed) {
                this.payWindow.close();
              }

              this.$message.error('Redirect URL is empty');
              return;
            }

            console.log('返回跳转地址:', d.redirectUrl);

            // 把已经打开的窗口跳到支付页面
            window.location.href = d.redirectUrl;


          }else {
            this.payResult = 'failed';
          }

        }else {
          this.$message.error(res.data.msg || "Request Failed");
        }
        //this.$message.success("Submit Success");
      } catch (e) {
        this.$message.error("Submit Failed");
      } finally {
        this.submitting = false;
      }
    },

    validateForm() {
      const rules = [
        { field: 'cardNo',    label: 'card number',    type: 'input' },
        { field: 'cvv',       label: 'CVV code',       type: 'input' },
        { field: 'expYear',   label: 'expire year',    type: 'select' },
        { field: 'expMonth',  label: 'expire month',   type: 'select' },
        { field: 'firstName', label: 'first name',     type: 'input' },
        { field: 'lastName',  label: 'last name',      type: 'input' },
        { field: 'email',     label: 'email address',  type: 'input' },
        { field: 'phone',     label: 'phone number',   type: 'input' },
        { field: 'country',   label: 'country',        type: 'select' },
        { field: 'state',     label: 'state',          type: 'input' },
        { field: 'city',      label: 'city',           type: 'input' },
        { field: 'zipCode',   label: 'zip code',       type: 'input' },
        { field: 'address',   label: 'address',        type: 'input' },
      ];

      for (const rule of rules) {

        const value = this.form[rule.field];

        if (!value || (typeof value === 'string' && !value.trim())) {
          const verb = rule.type === 'select' ? 'select' : 'enter';
          this.$message.error(`Please ${verb} ${rule.label}.`);
          return false;
        }
      }

      // 卡号（）
      if (!/^\d{13,21}$/.test(this.form.cardNo)) {
        this.$message.error("Card number must be 13-19 digits.");
        return false;
      }

      if (!this.checkCardNumber(this.form.cardNo)) {
        this.$message.error("Invalid card number.");
        return false;
      }

      // CVV（3-4位数字）
      if (!/^\d{3,4}$/.test(this.form.cvv)) {
        this.$message.error("CVV must be 3 or 4 digits.");
        return false;
      }

      // 邮箱
      const em = this.form.email.trim();
      if (!this.isEmail(em)) {
        this.$message.error("Please enter a valid email address.");
        return false;
      }
      if (em.length > 50) {
        this.$message.error("Email must not exceed 50 characters.");
        return false;
      }

      if (!this.form.firstName || this.form.firstName.length < 1 || this.form.firstName.length > 20) {
        this.$message.error("Invalid first name (1-20 characters).");
        return false;
      }
      if (!this.form.lastName || this.form.lastName.length < 1 || this.form.lastName.length > 20) {
        this.$message.error("Invalid last name (1-20 characters).");
        return false;
      }

      // 手机（6-20位，允许数字 + - 空格 括号）
      if (!/^[0-9+\-\s()]{3,20}$/.test(this.form.phone)) {
        this.$message.error("Invalid phone number (6-20 digits).");
        return false;
      }

      // 城市（2-30个字符）
      const ci = this.form.city.trim();
      if (ci.length < 2 || ci.length > 30) {
        this.$message.error("City name must be 2-30 characters.");
        return false;
      }

      // ZIP（3-12个字符）
      const zip = this.form.zipCode.trim();
      if (zip.length < 3 || zip.length > 12) {
        this.$message.error("ZIP code must be 3-12 characters.");
        return false;
      }

      // 地址（3-50个字符）
      const addr = this.form.address.trim();
      if (addr.length < 3 || addr.length > 50) {
        this.$message.error("Address must be 3-50 characters.");
        return false;
      }

      // 有效期
  /*    if (!this.checkExpireDate()) {
        this.$message.error("Card has expired.");
        return false;
      }*/


      return true;
    },
    checkCardNumber(cardNo) {

      let sum = 0;
      let shouldDouble = false;

      for (let i = cardNo.length - 1; i >= 0; i--) {

        let digit = parseInt(cardNo.charAt(i), 10);

        if (shouldDouble) {

          digit *= 2;

          if (digit > 9) {
            digit -= 9;
          }

        }

        sum += digit;
        shouldDouble = !shouldDouble;
      }

      return sum % 10 === 0;
    },
    resetForm() {
      this.payResult = null;
      this.resultData = { orderNo: '', amount: '', currency: '', dates: '', reason: '' };
    },

    /**
     * 初始化年份
     */
    initYear() {
      const currYear = new Date().getFullYear();

      this.yearList = [];

      for (let i = 0; i <= 12; i++) {
        this.yearList.push(currYear + i);
      }
    },

    /**
     * 选择年份后刷新月份
     */
    changeMonth() {

      this.form.expMonth = "";

      const now = new Date();
      const currYear = now.getFullYear();
      const currMonth = now.getMonth() + 1;

      this.monthList = [];

      if (!this.form.expYear) {
        return;
      }

      let startMonth = 1;

      if (Number(this.form.expYear) === currYear) {
        startMonth = currMonth;
      }

      for (let i = startMonth; i <= 12; i++) {
        this.monthList.push(i < 10 ? "0" + i : "" + i);
      }

    },

    /**
     * 邮箱验证
     */
    isEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    /**
     * 提交支付
     */
 /*   async submitPayment() {

      if (!this.isEmail(this.form.email)) {
        this.$message.error("Please enter valid email address!");
        return;
      }

      this.submitting = true;

      try {

        // const res = await this.$axios.post("/api/xxx", this.form);

        this.$message.success("Submit Success");

      } catch (e) {

        this.$message.error("Submit Failed");

      } finally {

        this.submitting = false;

      }

    }*/

  }

};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

.main-wrap {
  display: flex;
  width: 100%;
  max-width: 980px;
  margin: 20px auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0,0,0,.1);
  overflow: hidden;
  min-height: calc(100vh - 40px);
}

.left-order {
  width: 32%;
  background: #f8f9fa;
  padding: 35px 25px;
  border-right: 1px solid #e5e7eb;
}

.left-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 30px;
}

.order-item {
  margin-bottom: 25px;
}

.order-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 5px;
}

.order-val {
  font-size: 15px;
  color: #111827;
  font-weight: 500;
  word-break: break-all;
}

.right-form {
  width: 68%;
  padding: 30px 25px;
}

.form-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
}

.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 15px;
}

.form-col {
  flex: 1;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-size: 13px;
  color: #374151;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-size: 13px;
}

input:focus,
select:focus {
  outline: none;
  border-color: #409EFF;
}

.submit-btn {
  width: 100%;
  height: 40px;
  background: #409EFF;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 8px;
  transition: .3s;
}

.submit-btn:hover {
  background: #337ecc;
}

.submit-btn:disabled {
  cursor: not-allowed;
  background: #a0cfff;
}

.required {
  color: #f56c6c;
}

@media (max-width:768px) {

  .main-wrap {
    flex-direction: column;
    min-height: auto;
    margin: 10px;
  }

  .left-order {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    padding: 20px;
  }

  .right-form {
    width: 100%;
    padding: 20px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

}

/* ===== 结果页通用样式 ===== */
.container {
  background: #fff; padding: 40px; border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); text-align: center;
  max-width: 400px; width: 100%; margin: auto;
}
.success-icon {
  width: 80px; height: 80px; background: #4CAF50; border-radius: 50%;
  display: flex; justify-content: center; align-items: center;
  margin: 0 auto 20px; font-size: 40px; color: #fff;
}
.failed-icon {
  width: 80px; height: 80px; background: #f44336; border-radius: 50%;
  display: flex; justify-content: center; align-items: center;
  margin: 0 auto 20px; font-size: 40px; color: #fff;
}
h1 { color: #333; margin-bottom: 10px; }
p {
  color: #666; font-size: 16px; line-height: 1.6;
  letter-spacing: 0.5px; text-align: left; margin-bottom: 10px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.label { font-weight: bold; color: #333; margin-right: 8px; }
.reason { font-weight: bold; color: #f44336; }
.btn {
  display: inline-block; padding: 10px 20px; color: #fff;
  text-decoration: none; border-radius: 4px; font-weight: bold;
  margin-top: 20px; cursor: pointer;
}
.btn-success { background: #4CAF50; }
.btn-failed { background: #f44336; }

.payment-mask{
  position:fixed;
  left:0;
  top:0;
  right:0;
  bottom:0;

  background:rgba(0,0,0,.45);

  display:flex;
  align-items:center;
  justify-content:center;

  z-index:9999;
}

.payment-dialog{

  width:420px;
  background:#fff;

  border-radius:16px;

  padding:35px;

  box-shadow:
      0 20px 60px rgba(0,0,0,.18);

  animation:popup .25s ease;
}

@keyframes popup{

  from{
    opacity:0;
    transform:scale(.85);
  }

  to{
    opacity:1;
    transform:scale(1);
  }

}
.payment-dialog{
  width:420px;
  background:#fff;
  border-radius:16px;
  padding:35px;
  box-shadow:0 20px 60px rgba(0,0,0,.18);
  animation:popup .25s ease;
  text-align:center;
}

.dialog-title{
  font-size:28px;
  font-weight:600;
  color:#333;
  margin:18px 0 10px;
}

.reason{
  color:#f44336;
  font-size:16px;
  font-weight:600;
  margin-bottom:25px;
  text-align:center;
}

.dialog-info{
  text-align:left;
  border-top:1px solid #eee;
  border-bottom:1px solid #eee;
  padding:20px 0;
  margin-bottom:25px;
}

.info-item{
  display:flex;
  justify-content:space-between;
  margin-bottom:12px;
  font-size:14px;
}

.info-item:last-child{
  margin-bottom:0;
}

.label{
  color:#666;
  font-weight:600;
}

.failed-icon{
  width:80px;
  height:80px;
  margin:auto;
  border-radius:50%;
  background:#ff4d4f;
  color:#fff;
  font-size:44px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.success-icon{
  width:80px;
  height:80px;
  margin:auto;

  border-radius:50%;

  background:#52c41a;

  color:#fff;

  display:flex;
  align-items:center;
  justify-content:center;

  font-size:42px;
}
.success-text{
  text-align:center;
  color:#666;
  margin-bottom:24px;
  font-size:15px;
}
.success-btn{
  background:#52c41a;
}

.success-btn:hover{
  background:#389e0d;
}
</style>




// WEBPACK FOOTER //
// src/view/payment/Payment.vue